import parsePhoneNumber from 'libphonenumber-js';

const formatPhoneNumberInternational = (number: string): string => {
	if (!number) return '';

	const phoneNumber = parsePhoneNumber(`+${number.replace(/^\+/, '')}`);

	return phoneNumber ? phoneNumber.formatInternational() : number;
};

export default formatPhoneNumberInternational;
